export const ROLE = {
  ADMINISTRATOR: 1,
  USER: 2,
} as const

export const ROLE_LABEL = {
  [ROLE.ADMINISTRATOR]: "Administrator",
  [ROLE.USER]: "一般ユーザー",
} as const

export const USER_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
} as const
